import { useState } from "react";
import { FalloutCharacter } from "../Data/Response";
import styles from './EnemyTargetView.module.scss';

export interface Target {
    playerCharacter: FalloutCharacter,
    distance: number;
    isWideOpen: boolean;
}

type EnemyTargetViewArgs = {
    playerCharacter: FalloutCharacter,
    setTarget: (target?: Target) => void;
    isAreaAttack?: boolean;
}

const EnemyTargetView: React.FC<EnemyTargetViewArgs> = (args) => {
    const [distance, setDistance] = useState(0);
    const [isWideOpen, setIsWideOpen] = useState(false);
    const pc = args.playerCharacter;

    if (args.isAreaAttack) {
        return <li className={styles.enemyTarget}>
            <div className={styles.avatar}>
                <img src={pc.avatar.smallUrl} />
            </div>
            <div className={styles.info}>
                {pc.name}
                <br />
                Distance:
                <input type="number" onChange={e => {
                    e.preventDefault();
                    setDistance(parseInt(e.target.value));
                }} value={distance}></input>
                <br />
                <input
                    type="checkbox"
                    // checked={isWideOpen}
                    onChange={e => {
                        args.setTarget(e.target.checked ? {
                            playerCharacter: args.playerCharacter,
                            distance,
                            isWideOpen
                        } : null)
                        // setIsWideOpen(e.target.checked)
                    }}
                />
            </div>
        </li>
    }
    return <li className={styles.enemyTarget}>
        <div className={styles.avatar}>
            <img src={pc.avatar.smallUrl} />
        </div>
        <div className={styles.info}>
            {pc.name}
            <br />
            Distance:
            <input type="number" onChange={e => {
                e.preventDefault();
                setDistance(parseInt(e.target.value));
            }} value={distance}></input>
            <br />
            Is Wide Open
            <input type="checkbox" checked={isWideOpen} onChange={e => {
                setIsWideOpen(e.target.checked)
            }} />
            <button
                onClick={e => {
                    e.preventDefault();
                    args.setTarget({
                        playerCharacter: args.playerCharacter,
                        distance,
                        isWideOpen
                    })
                }}
            >Target {pc.name}</button>
        </div>
    </li>
}

export default EnemyTargetView;